"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargingSessionTrackerValidation = void 0;
const ChargingSessionValidation_1 = require("./ChargingSessionValidation");
class ChargingSessionTrackerValidation {
    static isValid(entity) {
        // Validate entity.charging_sessions for existence and correct type.
        if (entity.charging_sessions == undefined)
            return false;
        if (!Array.isArray(entity.charging_sessions))
            return false;
        if (!entity.charging_sessions.every((elem) => {
            if (!ChargingSessionValidation_1.ChargingSessionValidation.isValid(elem))
                return false;
            return true;
        }))
            return false;
        return true;
    }
}
exports.ChargingSessionTrackerValidation = ChargingSessionTrackerValidation;
